module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/devices/usb-storage-c5df12d9f35e94a1f9e93aaf23241437.svg";